import React, { useContext } from "react";
import { LangContext } from "../../../context/lang/LangContext";
import Colors from "../../../utils/enums/colors";
import { Link } from "gatsby";
import { useProductSubMenu } from "../hooks/useProductSubMenu";

interface Props {
  openSubMenu: boolean;
  handleCloseSubMenu: () => void;
}

export const ProductSubmenu = ({ openSubMenu, handleCloseSubMenu }: Props) => {
  const { messages } = useContext(LangContext);

  const { menuItems, menuSubItems, selectedSubMenu, setSelectedSubmenu } =
    useProductSubMenu();

  return (
    <>
      {openSubMenu && (
        <div
          onMouseLeave={handleCloseSubMenu}
          className="Header__product_container"
        >
          <div className="Header__product_sections_list">
            {menuItems.map((item) => (
              <div
                key={item.id}
                className="Header__product_sections_item"
                onClick={() => setSelectedSubmenu(item.id)}
              >
                {item.icon}
                <span
                  style={{
                    color:
                      selectedSubMenu === item.id ? Colors.Primary100 : "white",
                  }}
                >
                  {item.title}
                </span>
              </div>
            ))}
          </div>
          <div className="Header__product_sections_sublist">
            {menuSubItems
              .filter((item) => item.menuItemId === selectedSubMenu)
              .map((item, index) => (
                <Link
                  key={index}
                  className="Header__product_sections_subitem"
                  to={`/${messages.currentLanguage}/product/#${item.link}`}
                >
                  {item.title}
                </Link>
              ))}
          </div>
        </div>
      )}
    </>
  );
};
